<template>
  <base-content-page :page-title="pageTitle" :caption="pageDescription">
    <div class="text-h5 py-5">Hello. My name is Maurice Williams.</div>

    <p>
      I’ve been a small business owner for the past six years, and I know first-hand the challenges small businesses
      face.
    </p>

    <p>
      Most recently, the business landscape started to change dramatically. That change made me want to create a service
      to help small businesses grow and thrive in this new environment.
    </p>

    <p>
      Along with those changes, I understand the difficulties small business owners are facing. The biggest one is time.
      Time to run their business while at the same time managing the day-to-day logistics. In my experience, growing
      your venture and attracting new customers usually takes a backseat to running the business. Freeing up that time
      for business owners is what started me on my journey.
    </p>

    <p><span class="brand-name">Epic Receptionists</span> is where I landed.</p>

    <p>
      <span class="brand-name">Epic Receptionists</span> gives small business owners their time back. Time to invest
      back into their business. Time to run their business more efficiently. Time to enjoy all that they have already
      accomplished.
    </p>

    <p>
      In creating this company, not only do I want to solve the time issues for small businesses, but I want to approach
      this venture with a sense of integrity and transparency. These characteristics are mirrored in our core values.
    </p>

    <div v-for="(cv, index) in coreValues" :key="index" class="d-flex align-stretch justify-start mb-4">
      <div class="number text-h1 mr-2 mt-n2 text-center">{{ index + 1 }}</div>
      <div class="d-flex flex-column">
        <h2 class="font-weight-medium text-h6">{{ cv.name }}</h2>
        <ul>
          <li v-for="(item, i) in cv.items" :key="i">{{ item }}</li>
        </ul>
      </div>
    </div>
    <p>
      These core values are at the heart of our company. They shape the experience not only for the
      <span class="brand-name">Epic Receptionists</span>
      team but, most importantly, for you, our client.
    </p>
    <p>
      It is also vital to me that my efforts support communities that are so frequently left behind. Creating a
      sustainable business for my family and families like mine holds significant meaning for me.
    </p>
    <p>
      I know how hard it is to do everything. It’s impossible, and I know this first hand. With
      <span class="brand-name">Epic Receptionists</span>, you don’t have to do it all. We can be there when you can’t.
    </p>
    <p>
      Thank you for choosing <span class="brand-name">Epic Receptionists</span>. We take your business seriously and
      appreciate you making us a member of your small business team.
    </p>

    <me-card class="mt-10" />
  </base-content-page>
</template>
<script>
import BaseContentPage from '@/components/BaseContentPage'
import MeCard from '@/components/MeCard'

export default {
  components: {
    BaseContentPage,
    MeCard
  },

  data: () => ({
    pageTitle: 'About Us',
    pageDescription: 'This is who we are, what we value, and the things we strive for when conducting business',
    coreValues: [
      {
        name: 'Embrace and encourage diversity',
        items: ['Seek out new ideas, skills, and experiences', 'Variety is the spice of life']
      },
      {
        name: 'Freedom to grow the way you want',
        items: ['Supporting others in their journey, whatever that may be', 'Help those around us achieve their goals']
      },
      {
        name: 'Flexibility to work the way you need',
        items: [
          'Access to tools that fit the way you work',
          'Continuous evaluation of we offer to keep up with the changing world'
        ]
      },
      {
        name: 'Transparency and honesty as the basis of a trusted relationship',
        items: ['Setting the right expectations', 'Being accountable for our actions']
      },
      {
        name: 'Provide the best quality of service that we can',
        items: [
          'Life is too short for mediocrity',
          'As we improve ourselves, this will be reflected in the interactions around us'
        ]
      }
    ]
  }),

  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription
        }
      ]
    }
  }
}
</script>

<style scoped>
.number {
  font-size: 80px !important;
  width: 50px;
  /* margin-top: -24px; */
  color: lightgray;
}
</style>
